const PENDING_LOGIN_CODE_KEY = 'pending_login_code'
const PENDING_LOGIN_CODE_MS = 30 * 60 * 1000

type PendingLoginCode = {
  email: string
  at: number
}

export function storePendingLoginCode(email: string): void {
  const trimmed = email.trim()
  if (!trimmed || typeof localStorage === 'undefined') return
  const payload: PendingLoginCode = { email: trimmed, at: Date.now() }
  localStorage.setItem(PENDING_LOGIN_CODE_KEY, JSON.stringify(payload))
}

export function readPendingLoginCode(now = Date.now()): string | null {
  if (typeof localStorage === 'undefined') return null
  const raw = localStorage.getItem(PENDING_LOGIN_CODE_KEY)
  if (!raw) return null
  try {
    const parsed = JSON.parse(raw) as Partial<PendingLoginCode>
    if (typeof parsed.email !== 'string' || !parsed.email.trim()) {
      localStorage.removeItem(PENDING_LOGIN_CODE_KEY)
      return null
    }
    if (typeof parsed.at !== 'number' || now - parsed.at > PENDING_LOGIN_CODE_MS) {
      localStorage.removeItem(PENDING_LOGIN_CODE_KEY)
      return null
    }
    return parsed.email
  } catch {
    localStorage.removeItem(PENDING_LOGIN_CODE_KEY)
    return null
  }
}

export function clearPendingLoginCode(): void {
  if (typeof localStorage === 'undefined') return
  localStorage.removeItem(PENDING_LOGIN_CODE_KEY)
}
